var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlatformReports"},[_c('ShPageHeader',{attrs:{"title":"Lista raportów","description":"Lista raportów z wszystkich projektów IVR","breadcrumb-items":[
                  { label: 'zarządzanie' },
                  { label: 'lista raportów', path: '/reports' }
                ]}}),_c('ShPageLayout',[_c('ReportsList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }